<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>
              {{ source.title }}
              <open-on-site
                :source-route="source.route"
              />
            </h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body *</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <textarea id="summary" v-model="entity.summary" class="form-control" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Cover</label>
                  <div class="col-md-10">
                    <image-uploader
                      :uploaded-img-url="coverUrl"
                      @changeFile="changeCover"
                      @returnedOldFile="coverReturnOld"
                      @existingFileRemoved="coverRemove"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">Files</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          :options="dropzoneOptions"
                          :destroy-dropzone="false"
                          @vdropzone-success="fileUploadedSuccess"
                          @vdropzone-removed-file="fileRemoved"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Site page has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';

export default {
  name: 'SitePagesEdit',

  components: {
    dropzone: Dropzone,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [EditPageMixin],

  data() {
    return {
      source: null,
      entity: {},
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100,
      },
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'files[]',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}site-pages/${this.$route.params.id}/files`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    coverUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (_.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    },
  },

  methods: {
    manuallyAddFiles() {
      for (let i = 0; i < this.entity.files.length; i += 1) {
        const file = {
          file: {
            name: this.entity.files[i].file_name,
            size: this.entity.files[i].size,
          },
          url: this.entity.files[i].public_url,
          thumb: this.entity.files[i].thumbnail,
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.files[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    fileUploadedSuccess(file, response) {
      this.entity.files = response;
    },
    fileRemoved(file) {
      const fileIndex = _.findIndex(this.entity.files, item => item.file_name === file.name && item.size === file.size);
      this.$apiHttp.delete(
        `${this.$config.app_api.prefix}site-pages/${this.$route.params.id}/files/${this.entity.files[fileIndex].id}`,
      ).then(() => {
        this.entity.files.splice(fileIndex, 1);
      }).catch((err) => {
        console.error('error in delete file in site page request - ', err);
      });
    },
    changeCover(file) {
      this.entity.cover = file;
    },
    coverRemove() {
      this.entity.cover = null;
    },
    coverReturnOld() {
      this.entity.cover = this.source.cover;
    },
    isEntityValid() {
      const validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.body) {
        this.$_showError('Body field is required');
        return false;
      }
      if (this.entity.path_alias.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(
        `${this.$config.app_api.prefix}site-pages/${this.$route.params.id}?with[]=cover&with[]=files&with[]=path_alias`,
      ).then((response) => {
        this.source = response.data;
        this.entity = _.cloneDeep(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'cover')) {
          this.source.cover = null;
          this.entity.cover = null;
        }
        if (!Object.prototype.hasOwnProperty.call(response.data, 'path_alias')) {
          this.source.path_alias = {
            path_alias: '',
          };
          this.entity.path_alias = {
            path_alias: '',
          };
        }
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        setTimeout(this.manuallyAddFiles, 100);
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting data request' });
        console.log('Error in get image gallery query', error);
      });
    },
    deleteCoverRequest() {
      return this.$apiHttp.delete(`${this.$config.app_api.prefix}site-pages/${this.$route.params.id}/cover`);
    },
    saveCoverRequest() {
      const postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}site-pages/${this.$route.params.id}/cover`,
        postFormData,
      );
    },
    saveRequest() {
      return this.$apiHttp.post(`${this.$config.app_api.prefix}site-pages/${this.$route.params.id}`, {
        title: this.entity.title,
        body: this.entity.body,
        summary: this.entity.summary ? this.entity.summary : '',
        seo_title: this.entity.seo_title,
        seo_description: this.entity.seo_description,
        path_alias: this.entity.path_alias.path_alias,
      });
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.coverIsChanged) {
        this.saveRequest().then(() => {
          this.$_successSave();
        }).catch((error) => {
          this.$_errorSave(error);
          console.error('Error in update article query', error);
        });
      } else if (!this.entity.cover) {
        axios.all([this.deleteCoverRequest(), this.saveRequest()]).then(axios.spread((cover, entity) => {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      } else {
        axios.all([this.saveCoverRequest(), this.saveRequest()]).then(axios.spread((cover, entity) => {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?e6e63a24